import { render, staticRenderFns } from "./LayoutMini.vue?vue&type=template&id=dd74900e"
import script from "./LayoutMini.vue?vue&type=script&lang=js"
export * from "./LayoutMini.vue?vue&type=script&lang=js"
import style0 from "./LayoutMini.vue?vue&type=style&index=0&id=dd74900e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports